export class GoogleWorkspaceSharedDrive {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "driveId",
            "baseName": "driveId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgUnitId",
            "baseName": "orgUnitId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceSharedDrive.attributeTypeMap;
    }
    constructor() {
    }
}
